import { TacoRating } from '@appsumo/dorado-react';

function AverageRating({ average, count }: { average: number; count: number }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded border border-gravel p-3">
      {!!average && (
        <h3 className="font-header text-4xl font-bold">
          {String(average).slice(0, 3)}
        </h3>
      )}
      <TacoRating averageRating={average} size="md" href="" />
      <p>{count} ratings</p>
    </div>
  );
}

export default AverageRating;
